import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import './plugins/base'
import vuetify from './plugins/vuetify'
import i18n from './i18n'
import * as firebase from 'firebase'
import 'firebase/analytics'
import 'firebase/auth'
import 'firebase/firestore'
import moment from 'moment'
import Notifications from 'vue-notification'
import VueApexCharts from 'vue-apexcharts'

import IngredientService from '@/services/IngredientService'
import AuthService from '@/services/AuthService'
import SearchService from '@/services/SearchService'

/*
* Firebase
*/
const configOptions = {
  apiKey: 'AIzaSyCsB6izZoSaTriOYOGhL1_UF1M9dTElnv4',
  authDomain: 'apif-prod.firebaseapp.com',
  databaseURL: 'https://apif-prod.firebaseio.com',
  projectId: 'apif-prod',
  storageBucket: 'apif-prod.appspot.com',
  messagingSenderId: '926253227177',
  appId: '1:926253227177:web:401553d4befd50bfec1db8',
  measurementId: "G-95J9ZL8NL1",
}
firebase.initializeApp(configOptions)
firebase.analytics()

firebase.auth().onAuthStateChanged(function (user) {
  store.dispatch('user/authStateChanged', user);
});

// init services
const authService = new AuthService()
const ingredientService = new IngredientService()
const searchService = new SearchService()

/*
* Prototype
*/
Vue.prototype.$v = Vue
Vue.prototype.$firebase = firebase
Vue.prototype.$db = firebase.firestore()
Vue.prototype.$storage = firebase.storage()
Vue.prototype.$ingredientService = ingredientService
Vue.prototype.$authService = authService
Vue.prototype.$searchService = searchService
Vue.prototype.$moment = moment
Vue.prototype.$appUrl = process.env.NODE_ENV === 'production' ? 'https://go.apif.app/#' : 'http://localhost:8080/#';

declare module 'vue/types/vue' {
  interface VueConstructor {
    $db: any;
  }
}

/*
* Plugins
*/
Vue.use(Notifications)
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

// Misc
Vue.config.productionTip = false

let app: any;

firebase.auth().onAuthStateChanged(user => {
  if(user && user.uid) {
    authService.updateUserSignedInInfo(user.uid)
  }
  if (!app) {
    app = new Vue({
      router,
      store,
      vuetify,
      i18n,
      render: h => h(App),
    }).$mount('#app')
    i18n.locale = localStorage.getItem('language') || 'en'
  }
});